/**
 * Created by Julio Perez on 9/20/2016.
 */
require('angular');

class NavLinksLegendService{
    constructor($sce){

        let vm = this;
        vm.sce = $sce;
        vm.data= require('./nav-links-legend-list.json');

    }

    getNavLinksLegend(){

        let vm = this;
        return vm.data;

    }


}


export default angular
    .module('navLinksLegendService', [])
    .service('navLinksLegendService', NavLinksLegendService)
    .name;

NavLinksLegendService.$inject = ['$sce'];


// WEBPACK FOOTER //
// ./src/app/ui/nav-links-legend/nav-links-legend.service.js